module.exports = __webpack_public_path__ + "img/9788992711081.22c38ab2.jpg";